<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        title='发票地址'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='600'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-select-search label="客户/公司" outlined  @on-change='customerChange' return-object ref='search' path='customer/customers' :rules="required" v-model='form.customerId'></v-select-search>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="抬头名称"  hide-details='auto' outlined  :rules="required" v-model="form.customerName"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    :items="headItems"
                    label="抬头类型"
                    :rules="required"
                    v-model="form.headType"
                    outlined
                    hide-details='auto'
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="纳税识别号"  hide-details='auto' outlined  :rules="required" v-model="form.taxNumber"></v-text-field>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12">
                  <v-text-field label="地址电话" :rules="required"  hide-details='auto' outlined  v-model="form.address"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="开户行及账号" :rules="required" hide-details='auto' outlined  v-model="form.bankName"></v-text-field>
                </v-col>
              </v-row>
              <v-divider class="my-5"></v-divider>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field label="邮寄联系电话"  hide-details='auto' outlined  v-model="form.mailPhone"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field label="邮寄联系人"  hide-details='auto' outlined  v-model="form.mailPersion"></v-text-field>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12">
                  <v-text-field label="邮寄地址"  outlined  v-model="form.mailAddress"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" class="px-2" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/customer/iaddress.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    name: 'CustomerContactsEdit',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          customerName: '',
          customerId: ''
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        headItems: [
          { text: '个人', value: 1 },
          { text: '企业', value: 2 }
        ],
        form: {
          id: '',
          customerId: '',
          customerName: '',
          headType: '',
          taxNumber: '',
          address: '',
          bankName: '',
          mailAddress: '',
          mailPhone: '',
          mailPersion: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.followTime = new Date(this.form.followTimeStr).getTime() / 1000
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      customerChange (item) {
        this.form.customerId = item.id
        this.form.customerName = item.name
      },
      dialogChange (val) {
        this.item.show = val
        this.form.customerId = this.item.customerId
        this.form.customerName = this.item.customerName
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
